import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=42920242&scoped=true"
import script from "./custom-select.vue?vue&type=script&lang=js"
export * from "./custom-select.vue?vue&type=script&lang=js"
import style0 from "./custom-select.vue?vue&type=style&index=0&id=42920242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42920242",
  null
  
)

export default component.exports